module.exports = __webpack_public_path__ + "img/dementia-warnings-test.3a342723.png";